export const APP_INSIGHTS_INSTRUMENTATION_KEY = process.env.CAR_COLOR_VIEWER_APP_INSIGHTS_INSTRUMENTATION_KEY || '';
export const API = process.env.CAR_COLOR_VIEWER_API || '';
export const CLOUD_NAME = process.env.CAR_COLOR_VIEWER_CLOUD_NAME || '';
export const GTM_ID = process.env.CAR_COLOR_VIEWER_GTM_ID || '';
export const WIDGET_URL = process.env.CAR_COLOR_VIEWER_WIDGET_URL || '';
